import { get, post, put } from '@api/request';

export async function fetchExemptionResets(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlogs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExemptionReset(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createExemptionReset(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlogs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function selectExemptionReset(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}/selectproperty`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchExemptionResetSummaryCounts(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}/counts`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExemptionResetPropertyList(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID, exemptionCode },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}/${exemptionCode}/exemptionlisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExemptionResetListing(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID, mode },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}/listing?previewOrFinal=${mode}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function finalizeExemptionReset(
  { appraisalNoticeService },
  authenticationToken,
  { exemptionResetLogID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/exemptionresetlog/${exemptionResetLogID}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
